import React from "react";
import styled from "styled-components";

import { darkGreen, ESCALATION_COLORS, lightGreyOutline } from "../../styles";
import {
  formatEscalationCode,
  getEscalationLevel,
} from "../../enums/Escalations";

export const ESCALATION_MAX = 5;

const Circle = styled.span<{ $tint: string; $px: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ $px }): number => $px}px;
  height: ${({ $px }): number => $px}px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ $tint }): string => $tint};
  box-shadow: inset 0 0 0 1px rgba(21, 50, 48, 0.08);
  font-family: "ApercuMedium";
  font-size: ${({ $px }): number => Math.max(7.5, Math.round($px * 0.38))}px;
  letter-spacing: -0.02em;
  color: ${darkGreen};
`;

const Meter = styled.span`
  display: inline-flex;
  gap: 3px;
`;

const Notch = styled.span<{ $fill: string }>`
  width: 12px;
  height: 3px;
  border-radius: 3px;
  background: ${({ $fill }): string => $fill};
`;

interface EscalationAvatarProps {
  code: string;
  size: number;
}

export const EscalationAvatar = ({
  code,
  size,
}: EscalationAvatarProps): JSX.Element => (
  <Circle
    $tint={ESCALATION_COLORS[getEscalationLevel(code)]}
    $px={size}
    aria-hidden="true"
  >
    {formatEscalationCode(code)}
  </Circle>
);

export const EscalationMeter = ({ level }: { level: number }): JSX.Element => (
  <Meter aria-hidden="true">
    {Array.from({ length: ESCALATION_MAX }, (_, i) => (
      <Notch
        key={i}
        $fill={i < level ? ESCALATION_COLORS[i + 1] : lightGreyOutline}
      />
    ))}
  </Meter>
);
